module.exports = __webpack_public_path__ + "img/home-ipad-fg_enBU.7ae4225.jpg";